var map = {
	"./birthday.svg": 95400,
	"./create_account.svg": 93912,
	"./place_order.svg": 13007,
	"./purchase_product.svg": 7240,
	"./refer_friend.svg": 60087,
	"./review_product.svg": 57224,
	"./visit_website.svg": 59877
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96151;